<template>
  <div class="d-inline">
   <span
     id="popover-options"
     data-toggle="popover"
     data-placement="bottom"
   >
     <a class="dropdown-toggle" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
        aria-expanded="false"></a>
   </span>
    <b-popover
      target="popover-options"
      triggers="hover"
      placement="bottom"
      custom-class="ml-4 select-all-options"
      :noninteractive="true"
    >
      <div class="row align-items-center border-bottom pl-2 pb-2">
        <div class="col-1">
          <input
            v-model="selectType"
            @change="updateSelectOption('PAGE')"
            type="radio"
            name="selectType"
            value="PAGE"
            id="page"
            class="mr-1"
          >
        </div>
        <div class="col">
          <label for="page">
            <span>Select all on current page</span> <br>
            <span
              class="form-label-small text-muted"> Only items visible <b>on this page</b> will be selected</span>
          </label>
        </div>
      </div>
      <div class="row align-items-center border-top pl-2 pt-2">
        <div class="col-1">
          <input
            v-model="selectType"
            @change="updateSelectOption('ALL')"
            type="radio"
            name="selectType"
            value="ALL"
            id="all"
            class="mr-1"
          >
        </div>
        <div class="col">
          <label for="all">
            <span>Select all filtered results</span><br>
            <span class="form-label-small text-muted"> All items <b>across all pages</b> matching your current filters will be selected</span>
          </label>
        </div>
      </div>
    </b-popover>
  </div>
</template>
<script>

export default {
  name: 'SelectAllOptions',
  data() {
    return {
      selectType: 'PAGE',
    };
  },
  props: {
    selectedType: {
      type: String,
      default: 'PAGE',
    },
  },
  methods: {
    updateSelectOption(option) {
      this.$emit('updateSelectOption', option);
    },
  },
  created() {
    this.selectType = this.selectedType;
  }
};
</script>

<style lang="scss">
.select-all-options {
  width: 290px;

  .arrow {
    display: none;
  }
}
</style>
